.followButton {
  position: fixed;
  bottom: 1.5rem;
  bottom: calc(1.5rem + env(safe-area-inset-bottom));
  left: 50%;
  transform: translateX(-50%);
  z-index: $zindex-floating;

  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 1rem;
  background-color: $blue-700;
  color: #fff;
  font-size: 1rem;
  border-radius: 99px;
  // transition in
  transition: bottom 0.3s;

  &:active {
    background-color: $blue-900;
  }
}

.hidden {
  // transition out
  transition: bottom 1s;
  bottom: -50px;
}

// tablet
@media (min-width: $min-tablet) {
  .followButton {
    font-size: 1.25rem;
    gap: 1rem;
    padding: 0.25rem 1rem;
  }
}
